import React, { Component } from 'react';
import { Tree, Input } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';
import { filter } from 'lodash';

const { TreeNode } = Tree;

class RightsCompanyTree extends Component {

    state = {
        autoExpandParent: true,
        selectedKeys: [],
        searchtext: '',
    }

    onSelect = (selectedKeys) => {
        //console.log('selected', selectedKeys);
        this.props.onSelected(parseInt(selectedKeys[selectedKeys.length - 1]));
    }
    onCheck = (checkedKeys, info) => {
        // console.log('Id:', info.node.props.eventKey);
        // console.log('checked:', info.checked)
        this.props.onChecked(parseInt(info.node.props.eventKey), info.checked)
    }
    setSearchText = (txt) => {
        this.setState({
            searchtext: txt.toLowerCase(),
        });
    }

    render() {

        let inheritEntitieIds = [];
        let checkedEntities = [];
        if (this.props.roledetails) {
            checkedEntities = filter(this.props.roledetails.securableEntities, function (e) {
                return e.active;
            }).map(e => e.entityId.toString());
            inheritEntitieIds = filter(this.props.roledetails.securableEntities, function (e) {
                return e.inherit;
            }).map(e => e.entityId);
        }

        const loop = data => data.map((item) => {
            let tit = `${item.name} - ${item.administrationNr}`;
            if (this.state.searchtext.length > 0) {
                const r = new RegExp(eval(`/${this.state.searchtext}/i`));
                if (item.name.match(r) || item.administrationNr.match(r)) {
                    tit = <span style={{ color: 'red', fontWeight:'bold' }}>{ `${item.name} - ${item.administrationNr}`}</span>
                }
            }
            const children = filter(this.props.companies, function (c) {
                return c.parentId == item.idCompany;
            });
            if (children && children.length) {
                return <TreeNode key={item.idCompany} title={tit} icon={() => (
                    inheritEntitieIds.includes(item.idCompany) ? <ArrowDownOutlined /> : null
                )} >{loop(children)}</TreeNode>;
            }
            return <TreeNode key={item.idCompany} title={tit}
                icon={() => (
                    inheritEntitieIds.includes(item.idCompany) ? <ArrowDownOutlined /> : null
                )} />;
        });
        const parentItems = filter(this.props.companies, function (c) {
            return c.parentId == 0;
        });

        return (
            <div className='companies' >
                <br />
                <Input.Search
                    placeholder="Zoek op"
                    onSearch={value => this.setSearchText(value)}
                    style={{ width: 300, marginLeft: 15, marginTop: 0, marginBottom: 10 }} />
                <br />
                <Tree blockNode checkable checkStrictly autoExpandParent={this.state.autoExpandParent}
                    onSelect={this.onSelect} onCheck={this.onCheck} showIcon
                    checkedKeys={checkedEntities}
                >
                    {loop(parentItems)}
                </Tree>

            </div>

        );
    }
}

export default RightsCompanyTree;  